import { render, staticRenderFns } from "./ThinkTank.vue?vue&type=template&id=04ff6fd0&"
import script from "./ThinkTank.vue?vue&type=script&lang=js&"
export * from "./ThinkTank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports